import { render, staticRenderFns } from "./assignEntries.vue?vue&type=template&id=1a31ad00&scoped=true"
import script from "./assignEntries.vue?vue&type=script&lang=js"
export * from "./assignEntries.vue?vue&type=script&lang=js"
import style0 from "./assignEntries.vue?vue&type=style&index=0&id=1a31ad00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a31ad00",
  null
  
)

export default component.exports